import { mfeRegistry } from "./registry.js";

export function getMfeByName(name) {
  return mfeRegistry.find((mfe) => mfe.name === name);
}

export function getMfeByRoutePrefix(pathname) {
  return mfeRegistry.find((mfe) => pathname.startsWith(mfe.routePrefix));
}

/**
 * Returns the `remotes` map consumed by `@module-federation/vite` in the
 * ispm host's vite config. Shape: `{ [scope]: "scope@url" }`.
 */
export function getViteRemotes() {
  return mfeRegistry.reduce((acc, mfe) => {
    acc[mfe.moduleFederation.scope] = `${mfe.moduleFederation.scope}@${mfe.moduleFederation.devUrl}`;
    return acc;
  }, {});
}
